<template>
	<db-col height="auto" class="popup-header" valign="middle" align="center" v-if="title">
		<db-icon icon="close-e" color="#AAA" class="close-icon" width="auto" size="42" height="36" @click="close" />
		<db-col class="auto-fill pd-right-48" valign="middle" align="center">
			<db-col class="pd-20-30" valign="middle" align="center">
				<db-label size="32" bold class="ellipsis">{{title}}</db-label>
			</db-col>
		</db-col>
	</db-col>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: ''
			},
			
			dir: {
				type: String,
				default: ''
			}
		},
		
		data(){
			return {
				animation: ''
			}
		},
		
		computed: {
			size(){
				const dir = this.dir.toLowerCase()
				if(dir === 'top' || dir === 'bottom'){
					return 40
				}
				return 60
			}
		},
		
		methods: {
			close(){
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../../assets/styles/vars.scss';
	
	.popup-header{
		position: relative;
		font-size: 32px;
		color: #666;
		font-weight: bold;
		min-height: 110px;
		
		.close-icon{
			transition: all .3s;
			margin-left: 24px;
			transform: translateX(10px);
		}
		
		.pd-right-48{
			padding-right: 64px;
		}
	}
</style>
